module.exports = {
  DragDrop: {
    PluginName: "Arrastrar y Soltar",
    content_box_name: "Content",
    Statement: "Arrastre y suelte la respuesta correcta en el espacio en blanco.",
    Question: "Pregunta",
    Feedback: "Explicación",
    FeedbackMsg:
      "Aquí puedes incluir una explicación acerca de la respuesta. Puedes desactivar esta opción en la barra de herramientas.",
    TrueFeedbackMsg:
      "Aquí puedes añadir una explicación sobre la respuesta correcta. Puedes desactivar esta opción en la barra de herramientas.",
    FalseFeedbackMsg:
      "Aquí puedes añadir una explicación sobre la respuesta incorrecta. Puedes desactivar esta opción en la barra de herramientas.",
    ShowFeedback: "Mostrar Explicación",
    Number: "Número de Respuestas",
    ShowLettersInsteadOfNumbers: "Mostrar letras en lugar de números",
    background_color: "Color de Fondo",
    border_color: "Color de Borde",
    border_size: "Grosor de Borde",
    border_style: "Estilo de Borde",
    box_style: "Estilo Caja",
    opacity: "Opacidad",
    padding: "Padding",
    pos: "Posición",
    radius: "Radio",
    source: "Fuente",
    Answer: "Respuesta",
    Number: "Número",
    Color: "Color",
  },
};
